module.exports = __webpack_public_path__ + "img/AdobeStock_172421142_Preview-4k.3d368775.jpg";